import { Component, Input, OnInit } from '@angular/core';
import { ConsoleService } from 'src/app/services/console/console.service';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import {SafeStyle , DomSanitizer} from '@angular/platform-browser';


@Component({
    selector: 'app-widget-document',
    templateUrl: './widget-document.component.html',
    styleUrls: ['./widget-document.component.scss'],
})
export class WidgetDocumentComponent implements OnInit {
    @Input() widgetID: any;
    widgetStyle:any;
    background:any ;

    documentData: any = {
        description: '',
        banner: { mob: '', thumb: '', url: '' },
        btnTxt: '',
        pdfUrl: '',
    };

    constructor(private widgetsService: WidgetsService,private consoleService:ConsoleService,private domSanitizer:DomSanitizer) { }

    async ngOnInit() {
        let widgetData:any = await this.widgetsService.getWidgetData(this.widgetID);
        if (widgetData) {
            this.documentData = widgetData;
            this.consoleService.consoleLog('widget-document:28 data', this.documentData)
        }
        if (widgetData && widgetData.style && Object.keys(widgetData.style).length != 0) {
            this.widgetStyle = widgetData.style;
            if(this.widgetStyle.backgroundImage){
                this.background = this.domSanitizer.bypassSecurityTrustStyle(`url(${this.widgetStyle.backgroundImage})`);
            }
            else if(this.widgetStyle.backgroundColor){
                this.background = this.widgetStyle.backgroundColor;
            }
            else{
                //this.background = 'transparent';
            }
        }
    }

    download() {
     // const browser: InAppBrowserObject = this.inAppBrowser.create(this.documentData.pdfUrl, '_system');
    }

}
